module.exports = __webpack_public_path__ + "media/images/applicant/logo-sp-4242d23ec58fda9374e8f9c48791bb6d.jpg";